/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { InspectorControls, useBlockProps } from '@wordpress/block-editor';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

import { Fragment } from '@wordpress/element';
import { BlockControls, AlignmentControl } from '@wordpress/block-editor';
import { ToggleControl, PanelBody, SelectControl } from '@wordpress/components';
import ServerSideRender from '@wordpress/server-side-render';

export default function Edit( props ) {
	const { setAttributes, attributes } = props;
	const { textAlign, tripContent, tabContent } = attributes;
	
	return (
		<div { ...useBlockProps() }>
			<Fragment>
				<BlockControls>
					<AlignmentControl
						value={textAlign}
						onChange={(nextAlign) => {
							setAttributes({ textAlign: nextAlign });
						}}
					/>
				</BlockControls>
				<InspectorControls>
					<PanelBody>
					<ToggleControl
						label={ __( 'Get From Trip Content' ) }
						checked={ tripContent }
						onChange={ () => setAttributes( { tripContent: ! tripContent } ) }
						help={ __( 'Disable to get content from global tabs.' ) }
					/>					
					<SelectControl
						label={__('Select Content From', 'wp-travel-blocks')}
						value={ tabContent }
						options={ [
							{
								label: __('Custom Tab One', 'wp-travel-blocks'),
								value:'1'
							},{
								label: __('Custom Tab Two', 'wp-travel-blocks'),
								value:'2'
							},{
								label: __('Custom Tab Three', 'wp-travel-blocks'),
								value:'3'
							},{
								label: __('Custom Tab Four', 'wp-travel-blocks'),
								value:'4'
							},{
								label: __('Custom Tab Five', 'wp-travel-blocks'),
								value:'5'
							}
						] }
						onChange={ (val) => setAttributes( { tabContent: val } ) }
					/>
					</PanelBody>
				</InspectorControls>
			</Fragment>
			<ServerSideRender
				block="wp-travel-blocks/trip-custom-content"
				attributes={ props.attributes }
			/>
		</div>
	);
}
